import { render } from "./StrategiesView.vue?vue&type=template&id=b5864e6a&scoped=true"
import script from "./StrategiesView.vue?vue&type=script&lang=js"
export * from "./StrategiesView.vue?vue&type=script&lang=js"

import "./StrategiesView.vue?vue&type=style&index=0&id=b5864e6a&lang=scss&scoped=true"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5864e6a"]])

export default __exports__